<template>
  <div>
    <h1>水肥控制</h1>
  </div>
</template>
<script>
export default {
  name: 'Fertilizer',
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/product/operate/Fertilizer.vue